import { render, staticRenderFns } from "./HeroTwo.vue?vue&type=template&id=5bc3aa4c&scoped=true&lang=pug&"
import script from "./HeroTwo.vue?vue&type=script&lang=js&"
export * from "./HeroTwo.vue?vue&type=script&lang=js&"
import style0 from "./HeroTwo.vue?vue&type=style&index=0&id=5bc3aa4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3aa4c",
  null
  
)

export default component.exports